export enum ActiveView {
  Date = 1,
  Month = 2,
  Year = 3,
}
